<template>
  <div class="carousel-navigation">
    <button
      class="carousel-navigation-button carousel-navigation-prev"
      :class="{ 'carousel-navigation-prev--disabled': prevDisabled }"
      @click.prevent="triggerPageAdvance('backward')"
    >
      <svg class="icon">
        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#arrow-back"></use>
      </svg>
    </button>
    <button
      class="carousel-navigation-button carousel-navigation-next"
      :class="{ 'carousel-navigation-next--disabled': nextDisabled }"
      @click.prevent="triggerPageAdvance('forward')"
    >
      <svg class="icon">
        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#arrow-icon"></use>
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  name: 'navigation',
  props: {
    prevDisabled: {
      type: Boolean,
      default: false,
    },
    nextDisabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    triggerPageAdvance(direction) {
      this.$emit('page-advance-click', direction);
    },
  },
};
</script>
